import React, { createContext, useContext, useState } from 'react';

const BreadcrumbContext = createContext();

export const useBreadcrumb = () => useContext(BreadcrumbContext);

export const BreadcrumbProvider = ({ children }) => {
    const [breadcrumb, setBreadcrumb] = useState([]);

    const updateBreadcrumb = (newBreadcrumb) => {
        setBreadcrumb(newBreadcrumb);
    };

    const updateDynamicBreadcrumb = (segments) => {
        setBreadcrumb(segments);
    };

    return (
        <BreadcrumbContext.Provider value={{ breadcrumb, updateBreadcrumb, updateDynamicBreadcrumb }}>
            {children}
        </BreadcrumbContext.Provider>
    );
};
